import { BlockStack, Box, Card, SkeletonBodyText, SkeletonDisplayText } from "@shopify/polaris";

export const CardSkeleton = ({ lines = 3 }: { lines?: number }) => (
  <Card>
    <Box minHeight="200">
      <BlockStack gap="400">
        <SkeletonDisplayText />
        <SkeletonBodyText lines={lines} />
      </BlockStack>
    </Box>
  </Card>
);
